export const cleanUnicodeCharacters = (text: string) => {
  return (
    text
      // удаляются непечатные символы (форматирование) из других редакторов
      .replace(
        /[\u0000-\u001F\u007F-\u009F\u200B-\u200D\uFEFF\u2028-\u2029\u200E-\u200F]/g,
        '',
      )
      // нестандартные пробелы из форматирования заменяются на дефолтный пробел
      .replace(/[\u00A0\u1680\u180E\u2000-\u200A\u202F\u205F\u3000]/g, ' ')
      // заменяются "мягкие" переносы строки на обычные
      .replace(/\u00AD/g, '\n')
      // выполняем нормализацию Unicode-строк используя форму NFKC (совместимая композиция) (Normalization Form KC - Compatibility Composition)
      // по сути, преобразуем текст в стандартизированную форму
      .normalize('NFKC')
  );
};
